/* eslint-disable */
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { connect } from "react-redux";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { ViewPlayers } from "../../../../api/AuthenticationServices";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
const ViewPlayer = (props) => {
  const theme = useTheme();
  const [records, setRecords] = useState([]);
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    console.log(config);
    try {
      const res = await ViewPlayers(config);
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", res.data.data);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }
  const columns = [
    {
      field: "name",
      headerName: "Name",
      cellClassName: "name-column--cell",
      // flex: 3,
    },

    {
      field: "age",
      headerName: "Age",
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "bornYear",
      headerName: "Year Born",
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "dateOfBirth",
      headerName: "DOB",
      // flex: 1,
    },

    {
      field: "fatherPhnNumber",
      headerName: "Phone Number",
      // flex: 1,
    },
    {
      field: "gender",
      headerName: "Gender",
      // flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "email",
      headerName: "Email",
      // flex: 1,
    },
    {
      field: "fatherName",
      headerName: "Father Name",
      // flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "motherName",
      headerName: "Mother Name",
      // flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={() => handleEdit(params.row)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEdit = (row) => {
    // Handle edit button click event here

    console.log("Row : ", row);
    navigate(`/admin/editplayer/`, {
      state: { playerRow: records.filter((obj) => obj.id === row.id) },
    });
  };
  return (
    <Box m="20px">
      <Header title="PLAYERS" subtitle="List of Players" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={records}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

function mapStateToProps(state) {
  return {
    loginToken: state.loginToken,
  };
}
export default connect(mapStateToProps)(ViewPlayer);
